module.exports = __webpack_public_path__ + "img/2.1d3021af.png";